<template>
 <div class="backdrop" @click.self="closeModal">
    <div id="twoColumnModalContent">
        <div id="body">
            <div class="block" style="text-align:right;margin-bottom: 0;" @click="closeModal">
              <b-button type="is-primary" outlined rounded >Close</b-button>
            </div>

            <template>
                <img id="signInModalLogo"
                     :src="require('@/assets/images/direct-sign-logo.png')"
              alt="Lightweight UI components for Vue.js based on Bulma"
              >
              <div id="signInModalBodyTopic">
                  <h3>Sign In to DirectSign to make your<br/>Sign work easy!</h3>
                  <p id="smallText">Enter your email and NIC number to sign in to your account and proceed.</p>
              </div>

                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-two-thirds">
                        <div class="box-1" style="height: 105%; margin-top: -2%">

                            <div class="mt-5">

                                <b-field

                                    :type="fieldValidation.email == ''? 'is-info' : 'is-danger'"
                                    :message="fieldValidation.email"
                                    label="Enter Your Email"
                                    label-position="on-border"
                                    style="padding-bottom: 10px;"
                                >
                                <b-input
                                    v-model="email"
                                    class="signInFormField"
                                    @input="resetInvalidFields('email')"
                                    placeholder="Jasoncarter@gmail.com"
                                    rounded
                                ></b-input>
                                </b-field>

                                <b-field

                                    :type="fieldValidation.nicNumber == ''? 'is-info' : 'is-danger'"
                                    :message="fieldValidation.nicNumber"
                                    label="Enter Your NIC Number"
                                    label-position="on-border"
                                    style="padding-bottom: 10px;"
                                >
                                <b-input
                                    v-model="nicNumber"
                                    class="signInFormField"
                                    @input="resetInvalidFields('nicNumber')"
                                    placeholder="962554870v"
                                    rounded
                                ></b-input>
                                </b-field>


                                <div class="buttons">
                                    <b-button type="is-primary" outlined rounded expanded :loading="formIsSubmitting" @click="submitFields">Sign In</b-button>
                                </div>
                                <div>
                                    <p>
                                        Don't Have an Account?
                                    </p>
                                    <div class="buttons">
                                        <b-button type="is-primary" outlined rounded expanded  @click="goToSignUp">Sign Up</b-button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
 </div>
</template>

<script>
export default {

    data(){
        return{
            // use to store input field validation status
           fieldValidation:{
               email: "",
                nicNumber : "",
           },

           // varibles to store field inputs
            email:'',
           nicNumber: '',
            formIsSubmitting: false,

            regex:{
                email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                customer_nic_old: /^([0-9]{9}[vVxX]{1})$/,
                customer_nic_new: /^([0-9]{12})$/,
                // customer_nic_new:/^([0-9]{9}[XxVv])$^[0-9]{12}$/,
            },
        }
    },
    props:{
        'headingArea' :{
            default : true
        },
        // 'isCustomerSignedIn':{
        // default: false
        // },

    },
    components:{

    },

    methods:{
        closeModal:function(){
            this.$emit('close')
        },

        // method to validate the input fields
        validateFiedls:function (){
            var formIsValid = true

            if(this.email === '' ){
                console.log("Invalid email")
                this.fieldValidation.email = 'Email cannot be empty'
                formIsValid = false
            }
            else if(!this.regex.email.test(this.email)){
                this.fieldValidation.email  = 'Please enter valid email address'
                formIsValid = false
            }

            if(this.nicNumber === ''){
                 console.log("Invalid NIC")
                this.fieldValidation.nicNumber = 'NIC cannot be empty'
                formIsValid = false
            }
            // else if(!this.regex.customer_nic_new.test(this.nicNumber)){

            //         this.fieldValidation.nicNumber = 'Only allowed old and new NIC formats'
            //         formIsValid = false


            // }
            else if((!this.regex.customer_nic_old.test(this.nicNumber) && !this.regex.customer_nic_new.test(this.nicNumber) ) ){
                this.fieldValidation.nicNumber = 'Only allowed old and new NIC formats'
                formIsValid = false
            }

            if(formIsValid){
                return true
            }
            else{
                return false
            }
        },

        submitFields : function(){
            if(this.validateFiedls()){
                var component = this
                console.log("Sign in Fields are valid")
                component.$root.customerData.email = this.email
                component.$root.customerData.nicNumber = this.nicNumber
                component.formIsSubmitting = true
                component.$http.post(component.$base_url+'/customer/login', {
                    email:component.$root.customerData.email,
                    nicNumber:component.$root.customerData.nicNumber,

                })
                    .then(function (data) {


                        var array =[]
                        array = data.data

                        if(array.success === true){
                            // this.$emit('successCustomerSignedIn')
                          let signedInCustomer = array.data.customer
                          console.log("received customer data : "+signedInCustomer.invitee_name)

                          //set signed in customer details
                          component.$root.customerData.name = signedInCustomer.invitee_name
                          component.$root.customerData.contactNumber = signedInCustomer.invitee_contact_number
                          component.$root.customerData.CustomerSignedIn=true
                          component.formIsSubmitting = false
                          component.isCustomerSignedIn=true
                          component.$router.push({name:'customerDashboard'})
                        }else{

                            component.$root.customerData.email = ''
                            component.email = ''
                            component.$root.customerData.nicNumber = ''
                            component.nicNumber = ''

                            component.$buefy.toast.open({
                                message: array.data.message,
                                type: 'is-danger'
                            })
                            component.formIsSubmitting = false
                        }

                    })
                    .catch(function (error) {
                        console.log(error)
                    });

            }
            else{
                console.log("Sign in Fields are invalid")
            }
        },

        goToSignUp : function(){
            console.log("goToSignUpPage")
            this.$emit('goToSignUpPage')
        },

        resetInvalidFields : function(field){
             this.fieldValidation[field] =''
        },
    }


}

</script>

<style scoped>
    #twoColumnModalContent{
        /*margin: 10% auto;*/
        width: 800px;
        background: white;
        border-radius: 20px;
        /*min-height: 100px;*/
        padding: 20px;
        line-height: normal;
        overflow-y: scroll;
        margin-top: 5%;
        margin-left: 5%;
        margin-right: 5%;
        margin-bottom: 5%;

    }
    .backdrop{
        top: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        justify-content: center;
        display: flex;

    }

    #signInModalLogo{
    width: 10%;
    margin-bottom: 25px;
   }

   #signInModalBodyTopic > h3 {
    font-size:22pt;
    color: #0837ae;
    font-weight: bold;
   }

   #signInModalBodyTopic > #smallText {
    font-size:10  pt;
    color: #A5A6B3;
    margin-bottom: 20px;
   }

   .signInFormField{
     /*margin-bottom: 30px;*/
   }

   .block{
    cursor:grab
   }
</style>
